// @flow

import Notifications from '../constants/Notifications';
import AsyncRequest from '../classes/AsyncRequest';
import { ajaxParameter } from '../classes/Helpers';
import AbstractPagination from './abstract/AbstractPagination';

export default class Pagination extends AbstractPagination {
  /**
   * Executes when the user paginates
   */
  handlePaginate(pData: Object): void {
    if (!pData.page) {
      throw new Error('Not all required variables are passed');
    }
    window.store.url.setPage(+pData.page);
    this.sendRequest();
  }

  /**
   * Send an API request
   */
  sendRequest(): void {
    AsyncRequest.get(window.location.href + ajaxParameter())
      .then(({ data }: Object) => {
        this.notify(Notifications.PAGINATED, { data: data });
        if (Object.prototype.hasOwnProperty.call(data, 'paginationView')) {
          this.rebuildComponent(data.paginationView);
        }
      })
      .catch((error: Error) => {
        this.notify(Notifications.ASYNC_FAILED);
        console.error(error.message);
      });
  }
}
